export default __webpack_public_path__ + "static/media/twitter.3bc4d30c.svg";